import type { Document } from '@contentful/rich-text-types';
import { BLOCKS } from '@contentful/rich-text-types';

export function getShortFrequencyAnswerData(original: Document): Document {
  return {
    ...original,
    content: original.content.filter((item) => item.nodeType === BLOCKS.PARAGRAPH),
  };
}
